import { render, staticRenderFns } from "./UserProfileTabWrapper.vue?vue&type=template&id=0fa281f3&scoped=true&"
import script from "./UserProfileTabWrapper.vue?vue&type=script&lang=js&"
export * from "./UserProfileTabWrapper.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileTabWrapper.vue?vue&type=style&index=0&id=0fa281f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa281f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
